import { Component, EventEmitter, Output, Input } from '@angular/core';
import { PlantService } from '../../services/plant.service';
import { Product as Plant } from 'app/models/Product';

@Component({
  selector: 'app-plant-filter',
  templateUrl: './plant-filter.component.html',
  styleUrls: ['./plant-filter.component.scss']
})
export class PlantFilterComponent {
  @Output() filtersChanged = new EventEmitter<any>();
  categories: string[] = [];
  packagingTypes: string[] = [];

  filter = {
    keyword: '',
    orderBy: '',
    category: '',
    packaging_type: ''
  };

  constructor(private plantService: PlantService) {
    this.plantService.getCategories().subscribe(categories => {
      this.categories = categories;
    });
    this.plantService.getPackagingTypes().subscribe(packagingTypes => {
      this.packagingTypes = packagingTypes;
    });
  }

  search() {
    this.filtersChanged.emit(this.filter);
  }

  reset() {
    this.filter = {
      keyword: '',
      orderBy: '',
      category: '',
      packaging_type: ''
    };
    // this.search();
  }
}
